import { useQuery } from "@tanstack/react-query";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import { fetchStudentNotifications } from "@/api/students";
import { QueryState } from "@/components/common/AsyncState";
import { StatusChip } from "@/components/common/StatusChip";
import { NOTIFICATION_CHANNEL_LABELS, NOTIFICATION_STATUS_LABELS } from "@/types/enums";
import { formatDateTime } from "@/utils/format";

export function StudentNotificationsTab({ studentId }: { studentId: string }) {
  const { data: notifications, isLoading, error } = useQuery({
    queryKey: ["student-notifications", studentId],
    queryFn: () => fetchStudentNotifications(studentId),
  });

  return (
    <QueryState isLoading={isLoading} error={error}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Дата</TableCell>
            <TableCell>Канал</TableCell>
            <TableCell>Текст</TableCell>
            <TableCell>Статус</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(notifications ?? []).map((n) => (
            <TableRow key={n.id}>
              <TableCell>{formatDateTime(n.sentAt ?? n.createdAt)}</TableCell>
              <TableCell>{NOTIFICATION_CHANNEL_LABELS[n.channel]}</TableCell>
              <TableCell>{n.text}</TableCell>
              <TableCell>
                <StatusChip label={NOTIFICATION_STATUS_LABELS[n.status]} />
              </TableCell>
            </TableRow>
          ))}
          {(notifications ?? []).length === 0 && (
            <TableRow>
              <TableCell colSpan={4} align="center">
                Уведомлений этому ученику ещё не отправляли.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </QueryState>
  );
}
